import {
  Home as HomeIcon,
  Search as SearchIcon,
  User as UserIcon,
  Users,
  ShieldCheck,
  MessageSquare,
} from 'lucide-react';

const EARTH_GOLD = '#B8893A';

export function HouseDivider({ width = 280 }) {
  const lineLen = (width - 56) / 2;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        margin: '14px auto 14px',
        width,
        maxWidth: '90%',
      }}
      aria-hidden="true"
    >
      <span style={{ flex: 1, height: 1, background: EARTH_GOLD, opacity: 0.5, maxWidth: lineLen }} />
      <HomeIcon size={24} color={EARTH_GOLD} strokeWidth={1.5} />
      <span style={{ flex: 1, height: 1, background: EARTH_GOLD, opacity: 0.5, maxWidth: lineLen }} />
    </div>
  );
}

export function BubbleLandlordIcon({ size = 40 }) {
  return <HomeIcon size={size} color={EARTH_GOLD} strokeWidth={1.5} />;
}

export function BubbleSearchIcon({ size = 40 }) {
  return <SearchIcon size={size} color={EARTH_GOLD} strokeWidth={1.5} />;
}

export function BubbleTenantIcon({ size = 40 }) {
  return <UserIcon size={size} color={EARTH_GOLD} strokeWidth={1.5} />;
}

export function StatFirmsIcon({ size = 22 }) {
  return <ShieldCheck size={size} color={EARTH_GOLD} strokeWidth={1.6} />;
}

export function StatReviewsIcon({ size = 22 }) {
  return <MessageSquare size={size} color={EARTH_GOLD} strokeWidth={1.6} />;
}

export function StatRentersIcon({ size = 22 }) {
  return <Users size={size} color={EARTH_GOLD} strokeWidth={1.6} />;
}

export function StatManagersIcon({ size = 22 }) {
  return <UserIcon size={size} color={EARTH_GOLD} strokeWidth={1.6} />;
}
